import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PageBackButton from "../PageBackButton";
import HeaderButtonWrapper from "./HeaderButtonWrapper";

const PageBackHeader = ({
  confirmFlightLocationUrl,
  status,
  requestId,
  customerEndCancel,
  onShowChat,
  id,
  isBusinessTrip,
  hasChildDocument
}) => {
  const navigate = useNavigate();
  return confirmFlightLocationUrl ? (
    <PageBackButton
      label="Confirm Request"
      handleClick={() => navigate("/user/dashboard/flight-listing")}
    />
  ) : (
    <>
      <HeaderWrapper>
        <PageBackButton
          label="Booking Status"
          handleClick={() => navigate("/user/bookings")}
        />
        <MobileButtonView>
          <HeaderButtonWrapper
            hasChildDocument={hasChildDocument}
            isBusinessTrip={isBusinessTrip}
            navigate={navigate}
            status={status}
            id={id}
            requestId={requestId}
            customerEndCancel={customerEndCancel}
            onShowChat={onShowChat}
          />
        </MobileButtonView>
      </HeaderWrapper>
    </>
  );
};

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const MobileButtonView = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default PageBackHeader;
